export default __webpack_public_path__ + "static/media/shrimp-and-garlic.afd05d2b.png";